import React, { useContext, useEffect } from 'react';
import { PersonalizationContext } from './PersonalizationContext';
import { graphql, useStaticQuery } from 'gatsby';
import { Location } from '@reach/router';
import Triggers from 'utils/triggers';

const match = (pattern, path) => {
	if (pattern === null)return true;
	const array = (Array.isArray(pattern) ? pattern : [pattern]);
	for (let expr of array) {
		expr = expr.replaceAll('*', '(.*?)');
		expr = `^${expr}$`;
		const re = new RegExp(expr, 'i');
		if (re.test(path))return true;
	}
	return false;
}

const PersonalizationTrigger = (props) => {
	const { visitor, score, getAudience, removeTriggerType } = useContext(PersonalizationContext);
	const location = props.location;
	const triggers = props.data.allAudiencesTrigger.edges.map(item => item.node);
	const audiences = props.data.allAudiencesAudience.edges.map(item => item.node);
	const href = location.href;
	const visitorID = visitor?.id;
	const siteUrl = props.data.site?.siteMetadata?.siteUrl||'';

	useEffect(() => {
		const uninitTriggers = [];
		if (typeof window === 'undefined')return;
		const pathname = location.pathname;
		triggers.forEach(trigger => {
			if (Array.isArray(trigger.url)) {
				trigger.url = trigger.url.map(url => url.replace(location.origin, '').replace(siteUrl, ''));
			}
			const isMatch = match(trigger.url, pathname);
			if (isMatch) {
				const triggerObj = Triggers[trigger.type];
				if (!!triggerObj === false)return;
				let returnFunc = triggerObj.init({trigger, pathname, location, getAudience, score, audiences});
				if (returnFunc)uninitTriggers.push(returnFunc);
			}
		});
		
		const triggerObj = Triggers.impersonate;
		let returnFunc = triggerObj.init({pathname, location, getAudience, score, audiences, removeTriggerType});
		if (returnFunc)uninitTriggers.push(returnFunc);

		const audience = getAudience();
		if (!!audience !== false) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: 'audience_view',
				page: location.pathname,
				audience: audience.name,
				audienceWeight: audience.weight,
				audienceScore: audience.score,
			});
		}
		return () => {
			uninitTriggers.forEach((fn) => fn());
		}
	}, [href, visitorID, getAudience, location, score, siteUrl, triggers, audiences, removeTriggerType]);

	return <>{props.children}</>
}

const PersonalizationTriggerComponent = (props) => {

	const data = useStaticQuery(graphql`
		query PersonalizationTrigger {
		  allAudiencesAudience(filter: {approved: {eq: true}, archived: {eq: false}, deleted: {eq: false}}) {
		    edges {
			    node {
			      name
				  permalink
			      id
				  defaultWeight
			    }
		    }
		  }
		  allAudiencesTrigger (filter: {deleted: {eq: false}, archived: {eq: false}, approved: {eq: true}}) {
		    edges {
		      node {
				id
				action
				lifespan
		        score
		        url
		        value
		        type
		        Audience {
		          object {
		            id
		            name
		            utm_campaign
		          }
		        }
		      }
		    }
		  }

		  site {
	        siteMetadata {
	          siteUrl
	        }
	      }

			}
	`);
	return (
		<Location>
			{locationProps => <PersonalizationTrigger data={data} {...props} {...locationProps} />}
		</Location>
	)
}

export default PersonalizationTriggerComponent;